import webviewFun from '@/utils/webview-fun'
import cal from './cal'
import constant from '@/constant'
import storageUtil from '@/utils/storage'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { getConfig } from '@/config'
import iconGirl from '@/assets/img/icon-girl@2x.webp'
import iconBoy from '@/assets/img/icon-boy@2x.webp'
import iconSecret from '@/assets/img/icon-secret@2x.webp'

dayjs.extend(utc) // 加载 UTC 插件
dayjs.extend(timezone) // 加载时区插件

const { getUserInfo } = webviewFun
const { common } = constant
const { REQUEST_EXPIRED, DATE_TIME_FORMAT } = common
const conf = getConfig()
/*
 * 将Promisr的结果和错误，转化为一个数组返回。
 * @params {Promise}
 * @return {array} [err, res]
 */
const to = (promise: Promise<any>) => promise.then((res) => [null, res]).catch((err) => [err, null])

/**
 *  延迟一定时间，单位毫秒。
 */
const sleep = async (time: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, time)
  })

// 设置 accesstoken 和 uid
const setUidToken = async function (query: any) {
  console.log('进入 setUidToken', query)
  let uid: any = null
  let accesstoken: any = null
  if (parseInt(query.uid) > 0 && query.accesstoken && query.accesstoken != '') {
    uid = query.uid
    accesstoken = query.accesstoken
  } else {
    let userInfo: any = await getUserInfo()

    console.log('不在 url 带入参数，dsBridge注入 userInfo', userInfo)

    if (
      userInfo &&
      userInfo.res &&
      userInfo.res.uid > 0 &&
      userInfo.res.accesstoken &&
      userInfo.res.accesstoken != ''
    ) {
      uid = userInfo.res.uid
      accesstoken = userInfo.res.accesstoken
    }
  }

  if (isNaN(parseInt(uid as any))) {
    return 0
  }

  console.log('设置 uid 进session', uid)
  console.log('设置 accesstoken 进session', accesstoken)

  storageUtil.setSessionStorage('accessToken', accesstoken)
  storageUtil.setSessionStorage('uid', uid)

  return parseInt(uid as any)
}

/**
 * 数字转换-活动用
 * @param {*} number
 * @param {*} decimalNum 小数位数
 * @returns
 */
const activityNumberThumbnail = (number: number, decimalNum: number = 1) => {
  const num = number / 10 // 接口返回的礼物积分放大了十倍
  if (num < 1000) {
    return num
  }

  if (num >= Math.pow(10, 3) && num <= 999999) {
    const codyNum = cal.divide(num, Math.pow(10, 3))
    const decimalIndex = String(codyNum).indexOf('.')
    // 只显示一位小数
    if (decimalIndex > -1) {
      return String(codyNum).substring(0, decimalIndex + decimalNum + 1) + 'K'
    }
    return codyNum + 'K'
  }

  if (num >= Math.pow(10, 6) && num <= 999999999) {
    const codyNum = cal.divide(num, Math.pow(10, 6))
    const decimalIndex = String(codyNum).indexOf('.')
    // 只显示一位小数
    if (decimalIndex > -1) {
      return String(codyNum).substring(0, decimalIndex + decimalNum + 1) + 'M'
    }
    return codyNum + 'M'
  }

  if (num > 999999999) {
    return '999.9M+'
  }
}

/**
 * 数字转换-数据中心用
 * @param {*} num
 * @returns
 */
const dataCenterNumberThumbnail = (num: number) => {
  if (num < Math.pow(10, 6)) {
    return numberThumbnail(num)
  }

  if (num >= Math.pow(10, 6) && num <= 999999999) {
    const codyNum = cal.divide(num, Math.pow(10, 6))
    const decimalIndex = String(codyNum).indexOf('.')
    // 只显示一位小数
    if (decimalIndex > -1) {
      return String(codyNum).substring(0, decimalIndex + 2) + 'M'
    }
    return codyNum + 'M'
  }

  if (num > 999999999) {
    return '999.9M+'
  }
}

const numberThumbnail = (num: number | string) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// 获取文件后缀
const getFileExtension = (url: string) => {
  try {
    // 从 URL 中提取文件名部分
    const filename = url.substring(url.lastIndexOf('/') + 1)
    // 确保 URL 包含文件名
    if (filename.indexOf('.') === -1) {
      throw new Error('No file extension found')
    }
    // 从文件名中提取后缀名
    const extension = filename.substring(filename.lastIndexOf('.') + 1)

    return extension
  } catch (error) {
    console.error('Invalid URL', error)
  }
}

// 获取媒体类型
const getMediaType = (showType: string, showUrl: string) => {
  if (showType) return showType
  return getFileExtension(showUrl)
}

// 获取url参数
function getUrlParameters(url: string) {
  if (!url) return
  const paramsObject: { [key: string]: string } = {}

  // 找到问号后面的部分
  const queryStringIndex = url.indexOf('?')
  if (queryStringIndex !== -1) {
    const queryString = url.slice(queryStringIndex + 1)

    // 分割参数
    const pairs = queryString.split('&')

    pairs.forEach((pair) => {
      const [key, value] = pair.split('=')
      if (key) {
        // 解码参数并添加到对象中
        paramsObject[decodeURIComponent(key)] = value ? decodeURIComponent(value) : ''
      }
    })
  }

  return paramsObject
}

function objectToQueryString(obj: any) {
  return new URLSearchParams(obj).toString()
}

// 检测是否支持webp
const checkWebPFeature = async (feature: 'lossy' | 'lossless' | 'alpha') => {
  const kTestImages = {
    lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
    lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
    alpha:
      'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
    animation:
      'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
  }

  return new Promise((resolve) => {
    const img = new Image()
    img.onload = function () {
      const result = img.width > 0 && img.height > 0
      resolve(result)
    }
    img.onerror = function () {
      resolve(false)
    }
    img.src = 'data:image/webp;base64,' + kTestImages[feature]
  })
}

interface ILangItem {
  name: string
  image_url: string
  name_en: string
  image_url_en: string
  [key: string]: any
}

const getLangItemName = (item: ILangItem) => {
  const language = storageUtil.getLocalStorage('language') || 'en'
  return item['name_' + language] || item.name
}

const getLangImgUrl = (item: ILangItem) => {
  const language = storageUtil.getLocalStorage('language') || 'en'
  return item['image_url_' + language] || item.image_url
}

/**
 * 是否为Null类型
 *
 * @param {*} obj
 * @returns
 */
function isNull(obj: any) {
  return Object.prototype.toString.call(obj) === '[object Null]'
}

/**
 * 是否为Undefined类型
 *
 * @param {*} obj
 * @returns
 */
function isUndefined(obj: any) {
  return Object.prototype.toString.call(obj) === '[object Undefined]'
}

/**
 * 数据是否为空
 * @param obj
 * @returns
 */
function isExist(obj: any) {
  return !isNull(obj) && !isUndefined(obj)
}

/**
 * 是否为空对象
 *
 * @param {*} obj
 * @returns
 */
function isEmptyObject(obj: any) {
  return isObject(obj) && Object.keys(obj).length === 0
}

/**
 * 是否为空数组
 *
 * @param {*} arr
 * @returns
 */
function isEmptyArray(arr: any) {
  return isArray(arr) && arr.length === 0
}

/**
 * 是否为Array类型
 *
 * @param {*} obj
 * @returns
 */
function isArray(obj: any) {
  return Object.prototype.toString.call(obj) === '[object Array]'
}

/**
 * 是否为Object类型
 *
 * @param {*} obj
 * @returns
 */
function isObject(obj: any) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}
// 比较版本
// 返回 0 如果两个版本相等。
// 返回 1 如果第一个版本大于第二个版本。
// 返回 -1 如果第一个版本小于第二个版本。
function compareVersion(version1: string, version2: string) {
  const v1 = version1.split('.').map(Number)
  const v2 = version2.split('.').map(Number)

  const length = Math.max(v1.length, v2.length)

  for (let i = 0; i < length; i++) {
    const num1 = v1[i] || 0 // 如果没有该部分，默认为 0
    const num2 = v2[i] || 0 // 如果没有该部分，默认为 0

    if (num1 > num2) {
      return 1
    }
    if (num1 < num2) {
      return -1
    }
  }

  return 0
}

/**
 * 获取url中的查询参数
 * @returns
 */
function getQuerySearch() {
  const queryString = window.location?.search || ''
  return queryString
}

/**
 * 解决请求竞态的问题，只有最后一次请求返回请求结果
 * @param {*} fn
 * @returns
 */
function onlyLastRequest(fn: (args: any) => Promise<any>) {
  let requestTime = 0

  return function requestFn(...args: any[]) {
    return new Promise((resolve, reject) => {
      const currentRequestTime = Date.now()
      requestTime = currentRequestTime

      fn(args)
        .then((res) => {
          if (currentRequestTime !== requestTime) {
            reject(REQUEST_EXPIRED)
            return
          }

          resolve(res)
        })
        .catch(reject)
    })
  }
}

/**
 * 函数防抖
 *
 * @param {function} fn 要执行的函数
 * @param {number} wait 等待时间
 * @param {boolean} immediate 是否立即执行，immediate为true时：立即执行，停止触发n秒后，才可以重新触发执行。immediate为false时：停止触发n秒后才执行
 * @returns {function}
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function debounce(fn: Function, ...args1: any[]): (...args: any[]) => void {
  let [wait, immediate] = args1

  if (wait === void 0) {
    wait = 500
    immediate = false
  }

  if (immediate === void 0) {
    immediate = false
  }

  let timer: any = null

  return function debounceFn(...args2: any[]) {
    if (timer !== null) {
      clearTimeout(timer)
    }

    if (immediate) {
      const callNow = timer === null
      timer = setTimeout(() => {
        timer = null
      }, wait)

      if (callNow) {
        fn.apply(fn, args2)
      }
    } else {
      timer = setTimeout(() => {
        fn.apply(fn, args2)
        timer = null
      }, wait)
    }
  }
}

/**
 * 函数节流
 *
 * 函数在一段时间内多次触发只会执行第一次，在这段时间结束前，不管触发多少次也不会执行函数。
 *
 * @param {*} fn
 * @param {number} [gapTime=500]
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function throttle(fn: (...args: any[]) => any, gapTime: number = 500): (...args: any[]) => void {
  let lastTime: number = 0

  // 返回新的函数
  return function throttleFn(...args: any[]) {
    const nowTime: number = Date.now()

    // 函数执行条件
    if (!lastTime || nowTime - lastTime > gapTime) {
      fn.apply(fn, args) // 将this和参数传给原函数
      lastTime = nowTime
    }
  }
}

/**
 * 复制文本到剪贴板
 *
 * @param {string} text
 */
function copyToClipboard(text: string) {
  const textArea = document.createElement('textarea')

  textArea.value = text
  document.body.appendChild(textArea)
  textArea.select()
  document.execCommand('copy')
  document.body.removeChild(textArea)
}

// 解析为沙特时间
function formatToShamsiDateTime(date?: dayjs.ConfigType, format = DATE_TIME_FORMAT): string {
  return dayjs(date).tz('Asia/Riyadh').format(format)
}

function formatDateTime(date?: dayjs.ConfigType, format = DATE_TIME_FORMAT): string {
  return dayjs(date).format(format)
}

/**
 * 获取距离明天凌晨0点还有多少秒
 * @param serverTime 服务器返回的时间字符串或时间戳
 */
function getSecondsToMidnightToUTC3(serverTime: number) {
  const now = new Date(serverTime)

  // 创建表示明天凌晨0点的Date对象
  const midnight = new Date(now)
  midnight.setHours(24, 0, 0, 0)

  // 计算时间差（毫秒）并转换为秒
  const diffInSeconds = Math.floor(cal.divide(cal.minus(midnight.getTime(), now.getTime()), 1000))

  // 加上5小时，得到距离明天凌晨5点的秒数 UTC+3
  return cal.plus(diffInSeconds, 5 * 60 * 60)
}

function isIOS() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent)
}

/**
 * 获取url中的文件扩展名
 *
 * @param {string} url
 * @param {string} [defaultExt='jpg']
 * @returns
 */
function getExtName(url: string, defaultExt = '.jpg') {
  const matchResult = url.match(/(\.(?:.*?))$/)

  if (!matchResult) {
    return defaultExt
  }

  return matchResult[1]
}

function isRtl(language: string): boolean {
  return ['ar', 'he', 'fa', 'ps', 'ur'].includes(language)
}

/**
 * 判断当前语言是否为 RTL 模式（自动从 storage 获取语言）
 * @returns {boolean} true-是 RTL 模式，false-不是 RTL 模式
 */
function isRtlMode(): boolean {
  const language = storageUtil.getLocalStorage('language') || 'en'
  return isRtl(language)
}

// 用于跟踪待处理的导航检查定时器
let navigationCheckTimer: NodeJS.Timeout | null = null

/**
 * 处理页面返回逻辑
 * @param {Function} navigate - react-router-dom 的 navigate 函数
 * @returns {void}
 * 返回逻辑：
 * 1. 如果浏览器历史记录长度 > 1，尝试使用 navigate(-1) 返回
 * 2. 如果 navigate(-1) 失败（路径未改变），使用 closeWebViewPage() 关闭 WebView 页面
 * 3. 如果历史记录长度 <= 1，直接使用 closeWebViewPage() 关闭 WebView 页面
 */
function handleBack(navigate: (delta: number) => void): void {
  // 清除之前的定时器，避免内存泄漏
  if (navigationCheckTimer) {
    clearTimeout(navigationCheckTimer)
    navigationCheckTimer = null
  }

  const hasHistory = window.history.length > 1
  const currentPath = window.location.pathname + window.location.search

  if (hasHistory) {
    // 记录当前路径
    const beforePath = currentPath

    // 尝试导航返回
    navigate(-1)

    // 延迟检查路径是否改变，如果路径未改变说明导航失败
    navigationCheckTimer = setTimeout(() => {
      const afterPath = window.location.pathname + window.location.search
      if (beforePath === afterPath) {
        // 导航失败，关闭 WebView
        webviewFun.closeWebViewPage()
      }
      // 清除定时器引用
      navigationCheckTimer = null
    }, 100)
    return
  }

  // 没有历史记录，直接关闭 WebView
  webviewFun.closeWebViewPage()
}

// 将毫秒换算成天数
function convertMillisecondsToDays(ms: number) {
  let days = ms / (1000 * 60 * 60 * 24)
  return days < 1 ? Number(days.toFixed(1)) : Math.floor(days)
}

// 判断是否是 voca 项目
function isVoca() {
  if (['vocaDev', 'vocaTesting', 'vocaUat', 'vocaProd'].includes(conf.realEnv)) {
    return true
  }
  return false
}

// 判断是否是俄罗斯域名
function isRussiaHost() {
  const hostname = window.location.hostname
  return hostname.toLowerCase().endsWith('.hobychat.ru')
}

function isProduction() {
  const NODE_ENV = import.meta.env.MODE
  // 判断是否是生产环境的条件，打包是生产环境，或者app传的环境是生产环境
  return ['vocaProd', 'production'].includes(NODE_ENV)
}

/**
 * 判断是否应该在未登录时跳转到登录页
 * @returns {boolean} true-应该跳转，false-不跳转
 */
function shouldRedirectToLogin() {
  // 开发环境不自动跳转登录页，方便调试
  const isDevelopment = import.meta.env.MODE === 'development'
  return !isDevelopment
}

/**
 * 格式化数字，每3位添加一个英文逗号
 * @param {number | string} num - 要格式化的数字
 * @returns {string} 格式化后的字符串，例如：12345678 -> "12,345,678"
 */
function formatNumber(num: number | string): string {
  const numStr = typeof num === 'number' ? num.toString() : num
  return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * 格式化数字，根据大小显示 K、M、B 等单位，保留2位小数
 * @param {number | string} num - 要格式化的数字
 * @returns {string} 格式化后的字符串，例如：1234 -> "1.23K", 1234567 -> "1.23M"
 */
function formatCompactNumber(num: number | string): string {
  const numValue = typeof num === 'string' ? parseFloat(num) : num

  if (isNaN(numValue)) {
    return '0'
  }

  if (numValue < 1000) {
    return numValue.toString()
  }

  if (numValue >= 1000 && numValue < 1000000) {
    const kValue = numValue / 1000
    return kValue.toFixed(2).replace(/\.?0+$/, '') + 'K'
  }

  if (numValue >= 1000000 && numValue < 1000000000) {
    const mValue = numValue / 1000000
    return mValue.toFixed(2).replace(/\.?0+$/, '') + 'M'
  }

  if (numValue >= 1000000000) {
    const bValue = numValue / 1000000000
    return bValue.toFixed(2).replace(/\.?0+$/, '') + 'B'
  }

  return numValue.toString()
}

/**
 * 根据性别获取对应的图标
 * @param {number | undefined} gender - 性别：1-男，2-女，其他-保密
 * @returns {string} 图标路径
 */
function getGenderIcon(gender?: number | string): string {
  switch (Number(gender)) {
    case 1:
      return iconBoy
    case 2:
      return iconGirl
    default:
      return iconSecret
  }
}

export default {
  to,
  sleep,
  setUidToken,
  activityNumberThumbnail,
  numberThumbnail,
  getFileExtension,
  getMediaType,
  checkWebPFeature,
  getUrlParameters,
  objectToQueryString,
  getLangItemName,
  getLangImgUrl,
  compareVersion,
  isArray,
  isEmptyArray,
  isEmptyObject,
  isObject,
  isNull,
  isUndefined,
  isExist,
  getQuerySearch,
  onlyLastRequest,
  debounce,
  throttle,
  copyToClipboard,
  formatToShamsiDateTime,
  getSecondsToMidnightToUTC3,
  dataCenterNumberThumbnail,
  isIOS,
  formatDateTime,
  getExtName,
  isRtl,
  isRtlMode,
  convertMillisecondsToDays,
  isVoca,
  isRussiaHost,
  isProduction,
  shouldRedirectToLogin,
  handleBack,
  formatNumber,
  formatCompactNumber,
  getGenderIcon,
}
